import React from 'react';
import { Container, Row, Col ,ProgressBar  } from 'react-bootstrap';
import loadingFiles from './images/illustration.png'

export default function Loader(props){
    const [progress, setProgress] = React.useState(0);
    React.useEffect(() => {
        if(props.visible === false){
            document.querySelector('.loading').classList.add('d-none');
        }else{
            document.querySelector('.loading').classList.remove('d-none');
        }
        const timer = setInterval(() => {
          setProgress((oldProgress) => {
            if (oldProgress === 100) {
              return 0;
            }
            const diff = Math.random() * 10;
            return Math.min(oldProgress + diff, 100);
          });
        }, 500);
        return () => {
          clearInterval(timer);
        };
      }, []);
      return (
        <div className="loading loader-component">
            <Row className="justify-content-center align-items-center ">
                <Col className="mb-3"  xs={7}>
                    <div>
                        <img src={loadingFiles}  className="img-fluid" alt="loading files"/>
                    </div>
                </Col>
                <Col xs={12}>
                    <Row className="m-0 justify-content-center align-items-center ">
                        <Col md={4} xs={9} className="w-100">
                            <ProgressBar className="bg-white"   animated now={progress} />
                        </Col>
                    </Row>
                </Col>
                <Col  className="mt-3" md={3} xs={8}>
                        <p className="text-white">{(props.text)?props.text : ''}</p>
                </Col>
            </Row>
        </div>
      );
}